var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1297 20.49L13.0082 14.3685C12.5223 14.7572 11.9636 15.0648 11.332 15.2915C10.7004 15.5184 10.0284 15.6317 9.31584 15.6317C7.55064 15.6317 6.05671 15.0203 4.83402 13.7977C3.61134 12.575 3 11.081 3 9.31584C3 7.55064 3.61134 6.05671 4.83402 4.83402C6.05671 3.61134 7.55064 3 9.31584 3C11.081 3 12.575 3.61134 13.7977 4.83402C15.0203 6.05671 15.6317 7.55064 15.6317 9.31584C15.6317 10.0284 15.5184 10.7004 15.2915 11.332C15.0648 11.9636 14.7572 12.5223 14.3685 13.0082L20.49 19.1297L19.1297 20.49ZM9.31584 13.6884C10.5304 13.6884 11.5628 13.2632 12.413 12.413C13.2632 11.5628 13.6884 10.5304 13.6884 9.31584C13.6884 8.10125 13.2632 7.06885 12.413 6.21864C11.5628 5.36844 10.5304 4.94334 9.31584 4.94334C8.10125 4.94334 7.06885 5.36844 6.21864 6.21864C5.36844 7.06885 4.94334 8.10125 4.94334 9.31584C4.94334 10.5304 5.36844 11.5628 6.21864 12.413C7.06885 13.2632 8.10125 13.6884 9.31584 13.6884Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5a13e2b9694ccc48e3e0d855e5c52e1d.svg";
export { ForwardRef as ReactComponent };